import React from 'react';
import { Grid, IconButton, Select, MenuItem, styled, Box } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import moment from 'moment';
export const Root = styled(Box)(({ theme }) => ({
    justifyContent: 'space-around',
    display: 'flex', // inferred from use of justifyContent
}));
export const IconContainer = styled(Box)(({ theme }) => ({
    padding: 5,
}));
export const IconRo = styled(Box)(({ theme }) => ({
    padding: 10,
    '&:hover': {
        background: 'none',
    },
}));
const MONTHS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const generateYears = (relativeTo, count) => {
    const half = Math.floor(count / 2);
    return Array(count)
        .fill(0)
        .map((y, i) => moment(relativeTo).year() - half + i); // TODO: make part of the state
};
const Header = ({ date, setDate, nextDisabled, prevDisabled, onClickNext, onClickPrevious }) => {
    const handleMonthChange = (event) => {
        setDate(moment(date).set('month', parseInt(event.target.value)).toDate());
    };
    const handleYearChange = (event) => {
        setDate(moment(date).set('year', parseInt(event.target.value)).toDate());
    };
    return (<Grid container alignItems='center' component={Root}>
      <Grid item component={IconContainer}>
        <IconButton component={IconRo} disabled={prevDisabled} onClick={onClickPrevious}>
          <ChevronLeft color={prevDisabled ? 'disabled' : 'action'}/>
        </IconButton>
      </Grid>
      <Grid item>
        <Select variant='standard' value={moment(date).month()} onChange={handleMonthChange} MenuProps={{ disablePortal: true }}>
          {MONTHS.map((month, idx) => (<MenuItem key={month} value={idx}>
              {month}
            </MenuItem>))}
        </Select>
      </Grid>

      <Grid item>
        <Select variant='standard' value={moment(date).year()} onChange={handleYearChange} MenuProps={{ disablePortal: true }}>
          {generateYears(date, 30).map(year => (<MenuItem key={year} value={year}>
              {year}
            </MenuItem>))}
        </Select>

        {/* <Typography>{format(date, "MMMM YYYY")}</Typography> */}
      </Grid>
      <Grid item component={IconContainer}>
        <IconButton component={IconRo} disabled={nextDisabled} onClick={onClickNext}>
          <ChevronRight color={nextDisabled ? 'disabled' : 'action'}/>
        </IconButton>
      </Grid>
    </Grid>);
};
export default Header;
